import { render, staticRenderFns } from "./RaceLinkListSection.vue?vue&type=template&id=aace5f5c&scoped=true"
import script from "./RaceLinkListSection.vue?vue&type=script&lang=ts"
export * from "./RaceLinkListSection.vue?vue&type=script&lang=ts"
import style0 from "./RaceLinkListSection.vue?vue&type=style&index=0&id=aace5f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aace5f5c",
  null
  
)

export default component.exports